import { ShoesState } from 'src/types'

export const MOCK_SHOES_STATE: ShoesState = {
  baseModel: {
    brand: 'atoms',
    productNumber: 'shoes-1',
    size: 0,
    description: '',
    image: {
      url: '/atoms/baseModels/shoes/shoes-1.jpg',
      width: 240,
      height: 155
    }
  },
  upperMaterial: {
    label: 'エナメル',
    value: 'enamel',
    price: 31050
  },
  size: {
    label: '23.5cm',
    value: '23.5'
  },
  openingPattern: {
    label: 'クォーターカット',
    value: 'quarterCut',
    price: 1400
  },
  vampStrapType: {
    label: 'ベルト式(同方向)',
    value: 'beltTypeSameDirection',
    price: 1400
  },
  tongue: {
    label: '立ちベロ',
    value: 'standingTongue'
  },
  outSole: {
    label: '樹脂底(EVA白)',
    value: 'resinSoleEvaWhiteCleats'
  },
  lineType: {
    label: 'ダブルライン',
    value: 'doubleLine',
    price: 0
  },
  toeGuard: {
    label: '不要',
    value: 'none',
    price: 0
  },
  toeGuardKind: {
    label: '未選択',
    value: 'unselected',
    price: 0
  },
  line: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  line2: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  vampStrap: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  vampStrapBelt1: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  vampStrapBelt2: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  vampStrapBelt3: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  stitch: {
    label: 'Rブルー',
    value: 'royalBlue',
    color: '#002bff'
  },
  tongueLinings: {
    label: 'シルバー',
    value: 'silver',
    color: 'silver'
  },
  middleCutOpening: {
    label: '未選択',
    value: 'unselected',
    color: '#fff'
  },
  atomsLabel: {
    label: 'ブラックxゴールド',
    value: 'blackGold'
  },
  magicBeltBase: {
    label: 'ブラック',
    value: 'black',
    color: '#141414'
  },
  magicBeltMaterial: {
    label: 'エナメル',
    value: 'enamel'
  },
  toeGuardColor: {
    label: '未選択',
    value: 'unselected',
    color: '#fff'
  },
  parts: {
    value: 'whole',
    label: '全体'
  },
  whole: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  mainUnit: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  toeReinforcement: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  vampStrapReinforcement: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  healReinforcement: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  sideReinforcement: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  openingReinforcement: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  opening: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  healDecoration: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  tongueFront: {
    label: 'ブラック',
    value: 'black',
    color: '#0a0a0a'
  },
  embroideries: [
    {
      id: 0,
      typeFace: {
        label: '',
        value: ''
      },
      position: {
        label: '',
        value: ''
      },
      color: {
        label: '未選択',
        value: 'unselected',
        color: ''
      },
      shadowColor: {
        label: '未選択',
        value: 'unselected'
      },
      edgeColor: {
        label: '未選択',
        value: 'unselected'
      },
      content: ''
    }
  ],
  figurePanelNum: 0,
  images: {
    front: '',
    side: '',
    rear: ''
  },
  personal: {
    userName: '',
    userNameKana: '',
    phoneNumber: '',
    mailAddress: '',
    league: '',
    remarks: ''
  }
}
